<template>
  <v-dialog :value="!!state.url" max-width="500px" persistent>
    <v-card class="pa-2">
      <v-card-title class="pt-1">
        <h3 class="text-h5 mb-0">A New Shopping Experience</h3>
      </v-card-title>
      <v-card-text>
        <p>
          Our store has moved to a new and improved site. You'll be redirected in
          {{ countdown }} seconds.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="redirect">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { newShopRedirect } from '@/utils/portalNavigation';

export default {
  name: 'NewShopRedirectDialog',
  data() {
    return {
      state: newShopRedirect,
      countdown: 5,
      timer: null,
    };
  },
  watch: {
    //* immediate: on a fresh load of /shop the guard sets the url before this mounts
    'state.url': {
      immediate: true,
      handler(url) {
        if (!url || this.timer) return;
        this.timer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) this.redirect();
        }, 1000);
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    redirect() {
      clearInterval(this.timer);
      window.location.assign(this.state.url);
    },
  },
};
</script>
